<res-loading [imageSrc]="imageSrc" [debounceTime]="300"></res-loading>

<res-layout>
  <res-header [username]="username" (loginCallback)="login()" (logoutCallback)="logout()">
    <img class="logo" [src]=myCeLogo>
    <span
      *ngIf="environment !== 'PR'"
      class="environment">{{environment}}
    </span>
  </res-header>
  	<res-nav-horizontal>
      <res-nav-item iconClass="glyphicon glyphicon-home" route="home" title="Home"></res-nav-item>
      <res-nav-item iconClass="glyphicon glyphicon-list" route="requests/view/all" title="View Requests"></res-nav-item>
      <res-nav-item iconClass="glyphicon glyphicon-grain" route="requests/create" title="New Request"></res-nav-item>
      <res-nav-item iconClass="glyphicon glyphicon-stats" route="reporting" title="Reporting"></res-nav-item>
      <res-nav-item iconClass="glyphicon glyphicon-question-sign" route="help" title="Help"></res-nav-item>
	</res-nav-horizontal>
  <res-body>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </res-body>
  <res-footer [year]="year" [version]="versionNumber"></res-footer>
</res-layout>

<app-login-modal
  [showModal]="showModal"
  [refreshUrl]="settings.silentRefreshUrl"
  (close)="closeModal()">
</app-login-modal>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/app.component.html